module.exports = __webpack_public_path__ + "img/step-5.57d4db53.jpg";